import React from 'react'
import moment from 'moment'

// Constants
import { REFI_DETAILS_BULLETS } from 'src/constants/refinance'

// Components
import Format from 'src/Components/shared/Format'
import { Text } from 'src/Components'
import Bullet from './Bullet'
import isARM from './isARM'
import { baseProps, PMI } from './Shapes'

const DetailsBullets = ({
  type,
  years,
  pmi,
  potential30Year,
  yearsInHome,
  rate,
}) => {
  const bullets = []
  let key

  if (isARM(type)) {
    key = 'arm'
  } else {
    key = 'fix'
  }

  bullets.push(
    <Bullet
      key={key}
      refiMessage={REFI_DETAILS_BULLETS[key]}
      values={{
        years,
        now_years: moment().year() + years,
      }}
    />
  )

  if (pmi) {
    key = 'pmi'
    bullets.push(
      <Bullet
        key={key}
        refiMessage={REFI_DETAILS_BULLETS[key]}
        values={{
          pmi: <Format.Currency value={pmi} />,
        }}
      />
    )
  }

  if (potential30Year) {
    key = potential30Year > 0 ? 'potential_good' : 'potential_bad'
    bullets.push(
      <Bullet
        key={key}
        refiMessage={REFI_DETAILS_BULLETS[key]}
        values={{
          yearsInHome,
          potential30Year: (
            <Text.Strong variant='neutralCool' variantCount='900'>
              <Format.Currency value={Math.abs(potential30Year)} />
            </Text.Strong>
          ),
        }}
      />
    )
  }

  key = 'rate'
  bullets.push(
    <Bullet
      key={key}
      refiMessage={REFI_DETAILS_BULLETS[key]}
      values={{
        nationalRate: <Format.Rate value={rate} />,
      }}
    />
  )

  return bullets
}

DetailsBullets.propTypes = {
  ...baseProps,
  pmi: PMI,
}

export default DetailsBullets
